const updates = [
  {
    date: '2026.07.30',
    tag: '平台公告',
    title: '51吃瓜黑料全新改版上线，视频加载速度提升300%',
    desc: '为提供更流畅的吃瓜视频在线观看体验，平台已完成重大技术升级，全面优化黑料视频播放性能。',
  },
  {
    date: '2026.07.29',
    tag: '内容更新',
    title: '「顶流塌房」专题累计收录326条爆料视频',
    desc: '2026年上半年塌房艺人相关51吃瓜黑料视频全面整理，按时间线完整呈现事件全貌。',
  },
  {
    date: '2026.07.28',
    tag: '社区动态',
    title: '瓜友社区单日互动量突破50万次创历史新高',
    desc: '随着多起重磅爆料事件持续发酵，51吃瓜黑料社区话题讨论热度持续攀升，吃瓜群众活跃度大幅提升。',
  },
  {
    date: '2026.07.27',
    tag: '内容更新',
    title: '「网红翻车」系列新增12条独家黑料爆料视频',
    desc: '头部主播带货翻车事件持续追踪，多位品牌方内部人士提供独家51吃瓜视频素材。',
  },
  {
    date: '2026.07.26',
    tag: '平台公告',
    title: '投稿爆料通道即日起升级，支持视频文件直传',
    desc: '优化投稿流程，爆料人可直接上传51吃瓜黑料视频素材，编辑团队承诺2小时内响应审核。',
  },
  {
    date: '2026.07.25',
    tag: '社区动态',
    title: '「娱乐圈税务大地震」话题阅读量突破8000万',
    desc: '税务部门持续加码稽查的消息引发全网热议，51吃瓜黑料相关专题浏览量再创新高。',
  },
  {
    date: '2026.07.24',
    tag: '内容更新',
    title: '「豪门恩怨」深度专题上线，盘点近十年十大婚变',
    desc: '从商业联姻破裂到家族企业控制权争夺，全面梳理娱乐圈与商界交织的豪门故事。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            51吃瓜黑料平台动态与内容更新快讯
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="relative">
            <div className="absolute left-4 md:left-5 top-0 bottom-0 w-0.5 bg-background-200"></div>

            <div className="space-y-6 md:space-y-8">
              {updates.map((update, i) => (
                <div key={i} className="relative pl-10 md:pl-12">
                  <div className={`absolute left-2.5 md:left-3.5 top-1.5 w-3 h-3 rounded-full border-2 ${
                    i === 0
                      ? 'bg-primary-500 border-primary-500'
                      : 'bg-background-50 border-background-300'
                  }`}></div>

                  <div className="rounded-xl bg-background-100 border border-background-200/50 p-4 md:p-5 hover:border-primary-200 transition-all duration-200">
                    <div className="flex flex-wrap items-center gap-3 mb-2">
                      <span className="text-xs text-foreground-500 flex items-center gap-1">
                        <i className="ri-calendar-line"></i>
                        {update.date}
                      </span>
                      <span className={`px-2.5 py-0.5 rounded-full text-xs font-bold ${
                        update.tag === '平台公告'
                          ? 'bg-accent-100 text-accent-700'
                          : update.tag === '内容更新'
                          ? 'bg-primary-100 text-primary-700'
                          : 'bg-secondary-100 text-secondary-700'
                      }`}>
                        {update.tag}
                      </span>
                    </div>
                    <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1.5">
                      {update.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                      {update.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}